module.exports = __webpack_public_path__ + "static/media/locDistance.2cad3ec9.svg";